export default __webpack_public_path__ + "static/NGSwv5HMAFg6IuGlBNMjxLsI8ahuQ2e8Smg-70f935717c2cb8f8df6f675f5c76ab25.woff2";